<template>
  <div>
    <div class="blackboard">
      <p v-if='joke' class="joke-content">{{ joke.Content }}</p>
      <div class="sentiment-div" v-if='joke'>
        <button class="sentiment-btn love" @click='loveIt'><i class="material-icons">favorite</i><p>{{ joke.Love }} loves</p></button>
        <button class="sentiment-btn dislike" @click='hateIt'><i class="material-icons">healing</i><p>{{ joke.Hate }} dislikes</p></button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'JokeView',
  data () {
    return {
      joke: null
    }
  },
  methods: {
    giveOpinion (action) {
      if (this.joke) {
        axios
          .patch(process.env.VUE_APP_JOKE_API_URL + action + this.joke._id)
          .then(response => {
            this.joke = response.data
            this.loadRandomJoke()
          })
      }
    },
    loveIt () {
      this.giveOpinion('/love/')
    },
    hateIt () {
      this.giveOpinion('/hate/')
    },
    loadRandomJoke () {
      axios
        .get(process.env.VUE_APP_JOKE_API_URL + '/random')
        .then(response => {
          this.joke = response.data
        })
    }
  },
  mounted () {
    this.loadRandomJoke()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.joke-content {
  color: #E8E8E8;
  font-size: 30px;
  text-align: left;
  white-space: pre-line;
  font-family: 'Pinyon Script', cursive;
}

.sentiment-div {
  text-align: right;
}

.sentiment-btn {
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.love {
  color: pink;
}

.dislike {
  color: grey;
}

.blackboard {
  padding: 45px;
  overflow-y: auto;
  background-image: url(../assets/chalkboard.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 10px;
  border: #B78240 solid 10px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/JokeView.vue